import BaseModel from "../base_model.js";

import LoadCountriesUseCase from "../../use_cases/admin/addresses/countries/list_countries_use_case.js";
class RawAddressModel extends BaseModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "country",
        displayName: this.fieldDisplayName("country"),
        type: "model",
        useCase: LoadCountriesUseCase,
        foreignKey: "countryId",
      },
      {
        name: "city",
        displayName: this.fieldDisplayName("city"),
        type: "text",
      },
      {
        name: "postalCode",
        displayName: this.fieldDisplayName("postalCode"),
        type: "text",
      },
      {
        name: "street",
        displayName: this.fieldDisplayName("street"),
        type: "text",
      },
      {
        name: "number",
        displayName: this.fieldDisplayName("number"),
        type: "text",
      },
      {
        name: "url",
        displayName: this.fieldDisplayName("url"),
        type: "text",
      },
    ]
  }

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "country",
        displayName: this.fieldDisplayName("country"),
        type: "model",
        useCase: LoadCountriesUseCase,
        foreignKey: "countryId",
      },
      {
        name: "city",
        displayName: this.fieldDisplayName("city"),
        type: "text",
      },
      {
        name: "postalCode",
        displayName: this.fieldDisplayName("postalCode"),
        type: "text",
      },
      {
        name: "street",
        displayName: this.fieldDisplayName("street"),
        type: "text",
      },
      {
        name: "number",
        displayName: this.fieldDisplayName("number"),
        type: "text",
      },
      {
        name: "url",
        displayName: this.fieldDisplayName("url"),
        type: "text",
      },
    ]
  }

  i18nScope() {
    return "model.addresses.address";
  }

}
const AddressModel = new RawAddressModel();

export { RawAddressModel, AddressModel }

